/**
 * Drill direction resolution (BUG-35). A drill without
 * `qa_settings.direction` is treated as 'Source to Target' everywhere:
 * the question is the source, the correct answer / choices / results are
 * the target(s).
 */
import type { DrillQaDirection } from 'src/types/course/drill';

export const DEFAULT_DIRECTION: DrillQaDirection = 'Source to Target';

/** The effective direction; a missing one means 'Source to Target'. */
export function resolveDirection(
  qaSettings: { direction?: unknown } | null | undefined,
): DrillQaDirection {
  return (
    (qaSettings?.direction as DrillQaDirection | undefined) ?? DEFAULT_DIRECTION
  );
}

/** True when the question is the target (direction 'Target to Source'). */
export function isTargetToSource(
  qaSettings: { direction?: unknown } | null | undefined,
): boolean {
  return resolveDirection(qaSettings) === 'Target to Source';
}
